<template>
	<div class="my-promotion">
		<div class="header">
			<div class="name acea-row row-center-wrapper">
				<div style="position: absolute;left: 0.2rem;">我的金币</div>
				<div class="record">
					1金币=1元
					<!-- <span class="iconfont icon-xiangyou"></span> -->
				</div>
			</div>
			<div class="num">{{ userInfo.new_jinquan || 0 }}</div>
			<div class="profit acea-row row-between-wrapper">
				<div class="item">
					<div>昨日收益</div>
					<div class="money">{{ userInfo.yesterDay || 0 }}</div>
				</div>
				<div class="item">
					<div>累计提现</div>
					<div class="money">{{ userInfo.extractTotalPrice || 0 }}</div>
				</div>
			</div>
		</div>
		<!-- <div class="bnt bg-color-red" @click="toCash">立即提现</div> -->
		<div class="list acea-row row-between-wrapper">
			<div class="item acea-row row-center-wrapper row-column" @click="geturl('/user/poster')">
				<!-- <span class="iconfont icon-erweima"></span> -->
				<img src="@assets/images/account2.png"class="item_img" >
				<div>推广名片</div>
			</div>
			<!-- <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/integral'"> -->
			<div class="item acea-row row-center-wrapper row-column"  @click="geturl('/user/integral')">
				<img src="@assets/images/account1.png" class="item_img">
				<div>我的积分</div>
			</div>
			<router-link class="item acea-row row-center-wrapper row-column" :to="'/user/commission'">
				<img src="@assets/images/account3.png" class="item_img">
				<div>我的金币</div>
			</router-link>
			<router-link class="item acea-row row-center-wrapper row-column" :to="'/user/account'">
				<img src="@assets/images/account4.png" class="item_img">
				<div>我的金券</div>
			</router-link>
			<div class="item acea-row row-center-wrapper row-column" @click="geturl('/user/promoter_list')">
				<img src="@assets/images/account5.png" class="item_img">
				<div>我的团队</div>
			</div>
			<div class="item acea-row row-center-wrapper row-column" @click="geturl('/user/promoter_order')">
				<img src="@assets/images/account6.png" class="item_img">
				<div>团队订单</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		getUser
	} from "../../../api/user";

	export default {
		name: "UserPromotion",
		components: {},
		props: {},
		data: function() {
			return {
				userInfo: {}
			};
		},
		watch: {
			$route(n) {
				if (n.name == "UserPromotion") this.getInfo();
			}
		},
		mounted: function() {
			this.getInfo();
		},
		methods: {
			getInfo: function() {
				let that = this;
				getUser().then(
					res => {
						that.userInfo = res.data;
						console.log(that.userInfo);
					},
					function(err) {
						that.$dialog.message(err.msg);
					}
				);
			},
			geturl:function(url){
				console.log(url)
				
				if(this.userInfo.is_c_vip == 2 || this.userInfo.vip_num >= 3){
					this.$router.push({
						path: url
					});
				}else{
					return this.$dialog.toast({
						mes: "您还没有推广权限！！"
					});
				}
				
			},
			toCash: function() {
				this.$router.push({
					path: "/user/user_cash"
				});
			}
		}
	};
</script>
